import { editorConfig } from '~config';
import { getState } from '~src/state';

export const scaleDimension = (input, scaleFactorKey = 'default') => {
  const scaleFactor = editorConfig.scalingFactors[scaleFactorKey];

  const format = getState('selected.formato');
  const { width, height } = format;
  const largestSize = width > height ? width : height;

  return largestSize * scaleFactor;
};
